// extracted by css-extract-rspack-plugin
export default {"root":"root-rOT6fM","title":"title-HAzHZb","text":"text-IdzNEH","close":"close-A2iD3e"};